/*
 * Repli « Voir plus / Voir moins » de la description de collection.
 *
 * Pattern WAI-ARIA Disclosure : un <button aria-expanded aria-controls> pilote
 * l'aperçu replié de la description. À l'inverse de la description produit (repli
 * par hauteur), l'aperçu est ici tronqué par structure, de façon responsive :
 *   - >= 1200px : on garde le contenu jusqu'au 2e paragraphe inclus ;
 *   - < 1200px  : on ne garde que le contenu jusqu'au 1er paragraphe inclus.
 * Tout ce qui suit la coupure est masqué.
 *
 * Amélioration progressive : le repli est appliqué PAR le JS (le HTML rend la
 * description complète). Sans JavaScript, rien n'est masqué et le bouton reste
 * caché (attribut hidden) → description intégrale, bonne pour le SEO.
 *
 * Deux paliers de masquage, posés une fois puis pilotés par CSS :
 *   - .collection-description__hidden     : après le 2e <p>, masqué dès qu'on est replié ;
 *   - .collection-description__hidden-sm  : du 2e <p> inclus (et contenu intercalé)
 *                                           jusqu'à lui, masqué seulement < 1200px.
 *
 * Survit aux re-rendus AJAX du filtrage : facets.js remplace l'innerHTML de
 * #JsCollectionProduct et le legacy wpbingo.js fait un replaceWith d'un de ses
 * enfants ; un MutationObserver ré-initialise les blocs ré-injectés. init() est
 * idempotent (marqueur data-collection-description-ready).
 *
 * Convention IIFE alignée sur assets/product-description.js.
 */
(function () {
  'use strict';

  // Doit rester synchronisé avec le @media (max-width: 1199px) de css-collection.css.liquid.
  var NARROW_QUERY = '(max-width: 1199px)';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init(wrapper) {
    if (wrapper.hasAttribute('data-collection-description-ready')) return;
    wrapper.setAttribute('data-collection-description-ready', '');

    var content = wrapper.querySelector('[data-collection-description-content]');
    var toggle = wrapper.querySelector('[data-collection-description-toggle]');
    if (!content || !toggle) return;

    // Repère, parmi les enfants directs, le 1er et le 2e paragraphe.
    var children = content.children;
    var firstP = -1;
    var secondP = -1;
    var paragraphs = 0;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName === 'P') {
        paragraphs += 1;
        if (paragraphs === 1) firstP = i;
        else if (paragraphs === 2) { secondP = i; break; }
      }
    }
    if (firstP === -1) return; // aucun paragraphe : rien à replier.

    // Marque chaque enfant selon le palier auquel il appartient.
    for (var j = 0; j < children.length; j++) {
      if (secondP !== -1 && j > secondP) {
        children[j].classList.add('collection-description__hidden');
      } else if (j > firstP) {
        children[j].classList.add('collection-description__hidden-sm');
      }
    }

    var anyHidden = content.querySelector('.collection-description__hidden') !== null;
    var anyNarrowHidden = content.querySelector('.collection-description__hidden-sm') !== null;
    if (!anyHidden && !anyNarrowHidden) return; // rien à replier à aucune largeur.

    var mql = window.matchMedia(NARROW_QUERY);
    var label = toggle.querySelector('[data-collection-description-toggle-label]') || toggle;
    var labelMore = toggle.getAttribute('data-label-more') || label.textContent || '';
    var labelLess = toggle.getAttribute('data-label-less') || labelMore;
    var userExpanded = false;

    function setExpanded(expanded) {
      wrapper.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? labelLess : labelMore;
    }

    // Y a-t-il du contenu masquable à la largeur courante ?
    function hasCollapsibleContent() {
      return anyHidden || (mql.matches && anyNarrowHidden);
    }

    function applyState() {
      if (userExpanded) {
        setExpanded(true);
        toggle.hidden = false;
        return;
      }
      if (hasCollapsibleContent()) {
        setExpanded(false);   // aperçu replié + bouton « Voir plus »
        toggle.hidden = false;
      } else {
        setExpanded(true);    // tout tient à cette largeur : affichage complet
        toggle.hidden = true; // rien à révéler
      }
    }

    toggle.addEventListener('click', function () {
      userExpanded = !wrapper.classList.contains('is-expanded');
      setExpanded(userExpanded);
    });

    // Le passage du seuil 1200px change le contenu masquable : on réévalue.
    if (mql.addEventListener) mql.addEventListener('change', applyState);
    else if (mql.addListener) mql.addListener(applyState); // Safari < 14

    applyState();
  }

  function initAll() {
    document.querySelectorAll('[data-collection-description]').forEach(init);
  }

  ready(function () {
    initAll();

    // Le filtrage AJAX ré-injecte le markup à l'intérieur de #JsCollectionProduct :
    // on ré-initialise les blocs ré-injectés (init idempotent).
    var host = document.getElementById('JsCollectionProduct');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(initAll).observe(host, { childList: true, subtree: true });
    }
  });
})();
